import React from "react";

export default function PolitiqueConfidentialite() {
  return (
    <div style={{ maxWidth: "800px", margin: "80px auto", padding: "0 20px", fontFamily: "Manrope, sans-serif", color: "#1a1a1a", lineHeight: "1.8" }}>
      <h1 style={{ fontSize: "2rem", fontWeight: "800", marginBottom: "40px" }}>Politique de Confidentialité</h1>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>1. Responsable du traitement</h2>
      <p>
        <strong>ALTER ENERGIES</strong> — François Delattre<br />
        1899 Côte de Pinel Garrigou, 47380 Pinel-Hauterive<br />
        Email : frs.delattre@gmail.com<br />
        Téléphone : 06 28 51 49 15
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>2. Données collectées</h2>
      <p>Dans le cadre du formulaire de devis, nous collectons :</p>
      <ul>
        <li>Nom et prénom</li>
        <li>Numéro de téléphone</li>
        <li>Description de votre projet</li>
      </ul>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>3. Finalité du traitement</h2>
      <p>
        Ces données sont collectées uniquement pour vous recontacter dans le cadre de votre demande de devis. Elles ne sont ni vendues, ni transmises à des tiers.
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>4. Durée de conservation</h2>
      <p>
        Vos données sont conservées pendant une durée maximale de 3 ans à compter de votre demande.
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>5. Vos droits</h2>
      <p>
        Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition à vos données. Pour exercer ces droits, contactez-nous à : <strong>frs.delattre@gmail.com</strong>
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>6. Cookies</h2>
      <p>
        Ce site utilise des cookies techniques nécessaires à son fonctionnement ainsi que des cookies Google Ads à des fins publicitaires. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.
      </p>

      <h2 style={{ fontSize: "1.2rem", fontWeight: "700", marginTop: "32px" }}>7. Contact</h2>
      <p>
        Pour toute question relative à vos données personnelles :<br />
        <strong>frs.delattre@gmail.com</strong><br />
        06 28 51 49 15
      </p>
    </div>
  );
}
